module.exports = __webpack_public_path__ + "fonts/EuclidFlex-Bold.cd85c26.otf";